import clsx from 'clsx'
import React, {useContext} from 'react'
import {makeStyles} from 'external/material'
import LinesEllipsis from 'react-lines-ellipsis'
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

import {TeacherContext} from 'teacher/context'

import AddStandards from 'teacher/components/add-standards'
import {isUUID} from 'helpers/utils'

const useStyles = makeStyles(standardStyles)

export default function Standard (props) {
  const classes = useStyles()
  const context = useContext(TeacherContext)
  const {translate} = context
  const {id, code, description, deleteStandard} = props
  return (
    <div className={classes.root}>
      <div className={clsx(classes.item, classes.content)}>
        <div className={classes.code}>{code == undefined ? translate("expectation") : code}</div>
        <div className={classes.description} title={description}>
          <LinesEllipsis
            text={description}
            maxLine={3}
            ellipsis="..."
            trimRight
            basedOn='letters'
          />
        </div>
      </div>
      <div className={clsx(classes.item, classes.actions)}>
        <div className={classes.delete} onClick={() => deleteStandard && deleteStandard(id)}>
          <FontAwesomeIcon icon={faTrashAlt} />
        </div>
      </div>
    </div>
  )
}

function standardStyles(theme) {
  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      justifyContent: 'flex-start',
      borderBottom: 'solid 1px #e2ecf2',
      "&:last-child": {
        borderBottom: 'none'
      }
    },
    item: {
      display: 'flex',
      flexDirection: 'column'
    },
    content: {
      cursor: 'default',
      flexGrow: 1,
      color: '#4e576e',
      overflowX: 'hidden',
      padding: '12px 10px 12px 20px',
    },
    code: {
      textTransform: 'uppercase',
      fontWeight: 'bold'
    },
    description: {
      color: '#838999',
      fontSize: '10.5pt',
      wordWrap: 'break-word'
    },
    actions: {
      justifyContent: 'center',
      paddingRight: 10
    },
    delete: {
      cursor: 'pointer',
      color: '#dd3636',
      padding: '8px 9px',
      "&:hover": {
        transform: 'scale(1.10)'
      }
    }
  }
}
